import { render } from "./TeamMembersPanel.vue?vue&type=template&id=727dcc4b&scoped=true"
import script from "./TeamMembersPanel.vue?vue&type=script&lang=js"
export * from "./TeamMembersPanel.vue?vue&type=script&lang=js"

import "./TeamMembersPanel.vue?vue&type=style&index=0&id=727dcc4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727dcc4b"]])

export default __exports__